// Catálogo das ações de automação agrupadas por categoria (estilo Ummense).
// Mapeia as 10 ações suportadas pelo backend para categorias, ícones e rótulos.

export const ACTION_CATALOG = [
  {
    category: 'TAREFAS',
    actions: [
      { type: 'create_task', icon: 'i-lucide-check-square' },
      { type: 'apply_task_group', icon: 'i-lucide-list-checks' },
    ],
  },
  {
    category: 'AUTOMACOES',
    actions: [
      { type: 'send_message', icon: 'i-lucide-message-square' },
      { type: 'trigger_flow', icon: 'i-lucide-network' },
      { type: 'trigger_webhook', icon: 'i-lucide-zap' },
    ],
  },
  {
    category: 'EQUIPE',
    actions: [
      { type: 'change_assignee', icon: 'i-lucide-user' },
      { type: 'add_watchers', icon: 'i-lucide-users' },
    ],
  },
  {
    category: 'TAGS',
    actions: [
      { type: 'add_tag', icon: 'i-lucide-tag', badge: 'i-lucide-plus' },
      { type: 'remove_tag', icon: 'i-lucide-tag', badge: 'i-lucide-minus' },
    ],
  },
  {
    category: 'FUNIL',
    actions: [
      { type: 'change_status', icon: 'i-lucide-flag' },
      { type: 'move_card', icon: 'i-lucide-arrow-right-left' },
    ],
  },
  {
    category: 'CARD',
    actions: [
      { type: 'create_card', icon: 'i-lucide-layout-dashboard' },
      { type: 'duplicate_card', icon: 'i-lucide-copy' },
    ],
  },
];

// Mapa type -> ícone, para renderizar rapidamente na lista.
export const ACTION_ICONS = ACTION_CATALOG.reduce((acc, group) => {
  group.actions.forEach(a => {
    acc[a.type] = a.icon;
  });
  return acc;
}, {});

// Chave i18n do rótulo de cada ação (reaproveita KANBAN.AUTOMATIONS.ACTIONS.*).
export function actionLabelKey(type) {
  return `KANBAN.AUTOMATIONS.ACTIONS.${type.toUpperCase()}`;
}

// Rótulo curto do agendamento a partir do trigger_config.schedule.
// Retorna null quando não há agendamento (execução imediata).
export function scheduleLabel(schedule) {
  const value = Number(schedule?.value) || 0;
  if (value <= 0) return null;

  const unitShort = {
    minutes: 'min',
    hours: 'h',
    days: 'd',
    months: 'mês',
    years: 'ano',
  };
  return `${value} ${unitShort[schedule.unit] || 'min'}`;
}
